<template>
  <div class="pa-park-note-banner" v-if="isLoadedParkNote" @click="handleClickBanner">
    <div class="pa-title">{{parkNote.title | nameTruncate}}</div>
    <div class="pa-description">{{parkNote.text | jpSmaryTruncate}}</div>
    <div class="pa-meta-field">
      <div class="pa-meta-banner-list">
        <PACommonBadgeBanner :count="parkNote.like_count">
          <template slot="icon">
            <font-awesome-icon icon="heart" />
          </template>
        </PACommonBadgeBanner>

        <PACommonBadgeBanner :count="parkNote.reply_num">
          <template slot="icon">
            <font-awesome-icon icon="comments" />
          </template>
        </PACommonBadgeBanner>
      </div>

      <div class="pa-character-meta">
        <CharacterIcon :character="parkNote.character" :clickable="false" />
        <div class="pa-name">{{parkNote.character.displayname | nameTruncate}}</div>
      </div>
    </div>
  </div>
</template>

<script>
import CharacterIcon from '@/components/Parts/CharacterIcon/CharacterIcon.vue'
import PACommonBadgeBanner from '@/components/Parts/PACommonBadgeBanner/PACommonBadgeBanner.vue'

import {GetParkNote} from '@/graphql/queries/ParkNote.graphql'

export default {
  props : {
    parkNoteId  : {
      default: null
    },

    link : {
      default: false
    }
  },

  components : {
    CharacterIcon,
    PACommonBadgeBanner
  },

  apollo : {
    parkNote : {
      query : GetParkNote,
      variables(){
        return {
          id : this.parkNoteId
        };
      },

      error(err){
        const simpleErrorSet = this.getApolloSimpleErrorFromApolloError(err);
        
        this.apolloResultValidation(simpleErrorSet);
      }
    }
  },

  computed : {
    isLoadedParkNote(){
      if(typeof this.parkNote === 'undefined'){
        return false;
      }else{
        return true;
      }
    }
  },

  methods : {
    handleClickBanner(){
      if(this.link === false) return;
      
      this.$router.push({
        name    : 'parks.note.detail',
        params  : {
          noteId: this.parkNote.id,
          parkId: this.parkNote.park.id
        },
      });
    }
  }
}
</script>

<style lang="scss">
@import "~bulma/sass/utilities/_all";
@import "@/assets/scss/_variables.scss";

.pa-park-note-banner{
  user-select: none;

  background-color:#C8A984;
  color:#604938;
  border-radius: 8px;
  padding:.5rem;

  .pa-title{
    font-size:1.2rem;
    border-bottom:2px solid #B0906A;
    letter-spacing: .05rem;
  }

  .pa-description{
    margin-top:.2rem;
    font-size:.85rem;
    letter-spacing: .5px;
    word-break: break-all;
  }

  .pa-meta-field{
    position: relative;

    .pa-meta-banner-list{
      position: absolute;
      top:0;
      left:0;
      padding-top:.3rem;
      padding-left:.3rem;
      display: flex;
      .pa-common-badge-banner{
        margin-right: .5rem;

        &:last-child{
          margin-right: 0;
        }
      }
    }

    .pa-character-meta{
      margin:.4rem auto 0;
      padding-top: .3rem;
      border-top:1px solid #c09f77;
      width:98%;
      
      display: flex;
      text-align: right;
      justify-content:flex-end;

      .pa-character-icon{
        color:#795B46;
        margin:0;
        width:30px;
        height:30px;
        background-color:#BD9C75;
        font-size:14px;
        line-height:28px;
      }

      .pa-name{
        margin-left: .3rem;
        line-height: 30px;;
      }
    }
  }

  @include from($desktop) {
    padding:12px;

    .pa-title{
      font-size:1.4rem;
    }

    .pa-description{
      margin-top:8px;
      font-size:1rem;
    }
  }
}
</style>